export default __webpack_public_path__ + "static/media/small-logo.433556c9.svg";